import { atom } from "recoil";

type modalInfo = {
  isOpen: boolean;
};

export const lendHistoryModalInfoState = atom<modalInfo>({
  key: "lendHistoryModalInfoState",
  default: {
    isOpen: false,
  }
});